import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  CardMedia,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { UseAddOrder } from "./UseAddOrder";
import { UseOrders } from "../OrdersPage/UseOrders";
import { useSnackbar } from "notistack";
import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import MapOrder from "./MapOrder";
import useBreakpoints from "../../hooks/useBreakpoints";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function SendDetail(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetExpressDeliveryCost } = UseAddOrder();

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Box gridColumn={isSmall ? "span 12" : "span 5"}>
        <Autocomplete
          disabled={
            props.myLocations.cityID || (props.state && props.state.cityID)
              ? false
              : true
          }
          value={props.sendType ? props.sendType : ""}
          size="small"
          onChange={(event, newValue) => {
            if (newValue) {
              if (newValue.title !== "ارسال عادی با پیک موتوری") {
                props.setDeliveryTimes([]);
              }
              props.setSendType({ title: newValue.title });
              props.setLastDelivery(newValue);
              props.setDelivery(newValue);
              props.setAllDelivery(true);

              props.setRow({
                ...props.row,
                deliveryCost: newValue.cost,
              });
              props.setState({
                ...props.state,
                deliveryID: undefined,
                deliveryType: newValue.title,
              });
            } else {
              props.setDeliveryTimes([]);
              props.setValueAuto({ name: "" });
              props.setSendType({ title: "" });
              props.setDelivery();
              props.setState({
                ...props.state,
                deliveryID: undefined,
                deliveryType: "",
              });
            }
          }}
          getOptionDisabled={(option) => option.disable == true}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props}>
                <CardMedia
                  sx={{ width: "30px", mr: 1 }}
                  component="img"
                  image={option?.icon}
                />
                <Typography variant="body2">{option?.title}</Typography>
              </li>
            );
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          getOptionLabel={(option) => {
            if (option) {
              return option.title;
            }
            return "";
          }}
          fullWidth
          options={props.deliveryType ? props.deliveryType : []}
          renderInput={(params) => (
            <TextField
              error={props.errorState.deliveryType}
              variant="outlined"
              {...params}
              label="نوع ارسال"
            />
          )}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 5"}>
        <Autocomplete
          size="small"
          value={props.valueAuto ? props.valueAuto : ""}
          onChange={(event, newValue) => {
            if (newValue) {
              props.setValueAuto({ name: newValue.name });
              props.setState({
                ...props.state,
                deliveryID: newValue.deliveryID,
              });
            } else {
              props.setValueAuto({ name: "" });
              props.setState({
                ...props.state,
                deliveryID: undefined,
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          getOptionDisabled={(option) =>
            option.disable == true || option.isFull == true
          }
          getOptionLabel={(option) => {
            if (option) {
              return option ? option.name : "";
            }
            return "";
          }}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props}>
                <Typography
                  sx={{
                    color: option.isFull && "red",
                  }}
                >
                  {option.name}
                </Typography>
              </li>
            );
          }}
          fullWidth
          options={props.deliveryTimes ? props.deliveryTimes : []}
          renderInput={(params) => (
            <TextField
              error={props.errorState.deliveryID}
              variant="outlined"
              {...params}
              label="بازه ارسال"
            />
          )}
        />
      </Box>
      {props.state.deliveryType == "ارسال سریع با پیک موتوری" ? (
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <Button
            variant="contained"
            onClick={() => {
              if (!props.myLocations.longitude || !props.myLocations.latitude) {
                props.setOpenAddress({ ...props.openAddress, show: true });
                enqueueSnackbar("لطفا آدرس را روی نقشه انتخاب کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
              setProgress(true);
              GetExpressDeliveryCost(
                props.orderID,
                props.myLocations,
                (callback) => {
                  props.setValueAuto({
                    name:
                      props.delivery.description +
                      " (" +
                      callback.costTitle +
                      ")",
                  });
                  enqueueSnackbar("هزینه ارسال محاسبه شد", {
                    variant: "success",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  props.setRow({
                    ...props.row,
                    deliveryCost: callback.cost,
                  });
                  props.setState({
                    ...props.state,
                    deliveryID: callback.deliveryID,
                  });
                }
              );
            }}
          >
            محاسبه هزینه ارسال
          </Button>
        </Box>
      ) : (
        ""
      )}
      {props.state.deliveryType == "ارسال عادی با پیک موتوری" ? (
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          {props.allDelivery == true ? (
            <Button
              variant="contained"
              onClick={() => {
                props.setAllDelivery(false);
                props.setDelivery(props.allDeliveryDay[0]);
                props.setRow({
                  ...props.row,
                  deliveryCost: props.allDeliveryDay[0].cost,
                });
                props.setState({
                  ...props.state,
                  deliveryType: props.allDeliveryDay[0].title,
                });
                props.setValueAuto({ name: "" });
                props.setState({
                  ...props.state,
                  deliveryID: undefined,
                });
              }}
            >
              تمام بازه ها
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                props.setAllDelivery(true);
                props.setDelivery(props.lastDelivery);
                props.setValueAuto({ name: "" });
                props.setState({
                  ...props.state,
                  deliveryID: undefined,
                });
              }}
            >
              بازه های فعال
            </Button>
          )}
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
}
